import {useEffect, useState} from "react";
import {Card, Col, Row} from "react-bootstrap";

import Header from "../../layouts/Header";
import Channels from "./Channels";
import Creativities from "./Creativities";
import Limits from "./Limits";
import AudienceHealth from "./AudienceHealth";
import QuickLinks from "./QuickLinks";
import {UsePut} from "../../hooks/http";
import {DateTime} from "luxon";
import colors from "../../resources/sass/_vars.scss";
import {DashboardBarWidth} from "../../config/Config";




const Dashboard = () => {
    const [submits, setSubmits] = useState();
    const [creativities, setCreativities] = useState();
    const [accountLimits, setAccountLimits] = useState();
    const [audienceHealth, setAudienceHealth] = useState();

    const currentDate = DateTime.now()
    const pastDate = currentDate.plus({days: -27})



    const fetchData = async () => {
        return UsePut(`/accounts/stats`, {})
    }



    const data = {
        labels: [],
        datasets: [
            {
                label          : 'Email',
                data: [],
                backgroundColor: colors.email,
                stack          : 'Stack 0',
                barThickness   : DashboardBarWidth,
            },
            {
                label          : 'Sms',
                data           : [],
                backgroundColor: colors.sms,
                stack          : 'Stack 0',
                barThickness   : DashboardBarWidth,
            },
            {
                label          : 'WebService',
                data           : [],
                backgroundColor: colors.webService,
                stack          : 'Stack 0',
                barThickness   : DashboardBarWidth,
            },
            {
                label          : 'Sftp',
                data           : [],
                backgroundColor: colors.sftp,
                stack          : 'Stack 0',
                barThickness   : DashboardBarWidth,
            },
        ],
    };



    const fetchSubmits = async () => {
        return UsePut(`/accounts/submits`, {
            data: {start_date: pastDate.toISODate(), end_date: currentDate.toISODate()}
        })
    }









    useEffect(() => {
        fetchData().then((response1) => {
            setCreativities(response1?.creativities)
            setAudienceHealth(response1?.health)
            setAccountLimits(response1?.limits)

            fetchSubmits().then((response2) => {
                response2.map((item, index) => {
                    data.datasets[0].data.push(item.email)
                    data.datasets[1].data.push(item.sms)
                    data.datasets[2].data.push(item.webservice)
                    data.datasets[3].data.push(item.sftp)
                    data.labels.push(pastDate.plus({days: index}).day)
                })
                setSubmits(data)
            })
        })
    }, [])


    return (
        <>
            <Header icon="dashboard" title="Dashboard"/>
            <div className="dashboard max-width-1067">
                <Row className="mb-4">
                    <Col lg={8}>
                        <Card className="min-height-auto max-height-450">
                            <Row>
                                <Col lg={12}>
                                    <Channels data={submits} />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col lg={4}>
                        <Card className="min-height-auto max-height-450">
                            <Creativities data={creativities} />
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col lg={4}>
                        <Card className="min-height-auto max-height-450">
                            <Limits data={accountLimits} />
                        </Card>
                    </Col>
                    <Col lg={4}>
                        <Card className="min-height-auto max-height-450">
                            <AudienceHealth data={audienceHealth} max={accountLimits?.leads?.count} />
                        </Card>
                    </Col>
                    <Col lg={4}>
                        <Card className="min-height-auto max-height-450">
                            <QuickLinks />
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default Dashboard;